import { DataTableColumn } from "../../../shared/components/data-table/DataTableColumn.model";
import { ReferenceService } from "../../../shared/reference/reference.service";
import { formatCurrencyString } from "../../../utilities/CurrencyUtility";
import { Currency } from "../../currencies/models/Currency";

export interface VerificationPackage {
    id: number;
    verification_package_id: number;
    organization_id: number;
    currency_id: number;
    price: number;
    created_date: Date;
    is_active: boolean;
    is_primary: string;
    verification_package: VerificationPackageDetail;
    currency: Currency
}

export interface VerificationPackageDetail {
    id: number,
    verification_package_id: number;
    organization_id: number;
    name: string;
    description: string;
    is_active?: boolean;
    status_id?: number;
    pillStatus?: string;
    created_date?: Date;
    updated_date?: Date;
}

export interface VerificationPackageRow {
    id: number;
    verification_package_id: number;
    organization_id: number;
    name: string;
    description: string;
    price?: number | string | null;
    price_number?: number;
    is_active?: any;
    pillStatus?: string;
    primaryStatus?: string;
}

export const OrgVerificationPackageColumns: DataTableColumn[] = [
    { column: 'id', display: 'ID' },
    { column: 'name', display: 'Name' },
    { column: 'description', display: 'Description' },
    { column: 'price', display: 'Price' },
    { column: 'primaryStatus', display: 'Primary' },
    { column: 'verificationPackagesButtons', display: '' }
]

export const VerificationPackageColumns: DataTableColumn[] = [
    { column: 'id', display: 'ID' },
    { column: 'name', display: 'Name' },
    { column: 'description', display: 'Description' },
    { column: 'pillStatus', display: 'Status' }
]

export const getPackageRowFromPackage = (verificationPackage: VerificationPackage, referenceService: ReferenceService, currencyCode: string): VerificationPackageRow => {
    let primaryCode;
    if (verificationPackage.is_primary) {
        primaryCode = "Primary"
    } 
    // else {
    //     primaryCode = "Secondary"
    // }

    let statusCode;
    if (verificationPackage.is_active) {
        statusCode = "Active"
    } else {
        statusCode = "Inactive"
    }

    return {
        id: verificationPackage.id,
        verification_package_id: verificationPackage.verification_package_id,
        organization_id: verificationPackage.organization_id,
        name: verificationPackage.verification_package.name,
        description: verificationPackage.verification_package.description,
        price: formatCurrencyString(verificationPackage.price?.toString(), currencyCode),
        price_number: verificationPackage.price,
        is_active: verificationPackage.is_active,
        pillStatus: statusCode,
        primaryStatus: primaryCode
    }
}

export const getVerificationPackageDetailRowFromPackage = (verificationPackage: VerificationPackageDetail): VerificationPackageRow => {
    let statusCode;
    if (verificationPackage.status_id === 1) {
        statusCode = "Active"
    } else {
        statusCode = "Inactive"
    }

    return {
        id: verificationPackage.id,
        verification_package_id: verificationPackage.verification_package_id,
        organization_id: verificationPackage.organization_id,
        name: verificationPackage.name,
        description: verificationPackage.description,
        pillStatus: statusCode
    }
}

export const verificationPackageStatusIdToStatus = (statusId?: number) => {
    switch (statusId) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      default:
        return "";
    }
  }